import { PartnerOfferingForm } from '@components/offer-form/offer-form-second';
import { SectionKey } from 'types';

export enum WizardActionType {
  NEXT_QUESTION = 'NEXT_QUESTION',
  PREV_QUESTION = 'PREV_QUESTION',
  UPDATE_ANSWER = 'UPDATE_ANSWER',
  RESET_WIZARD = 'RESET_WIZARD',
  SET_FORM_DATA = 'SET_FORM_DATA',
  RESTORE_ANSWERS = 'RESTORE_ANSWERS'
}

export type WizardState = {
  activeWizardStep: SectionKey;
  activeSlide: number;
  activeSlideKey: keyof PvWizardResultsQueryVariables;
  isLastQuestion: boolean;
  isLastStep: boolean;
  isFirstStep: boolean;
  answers: PvWizardResultsQueryVariables;
  isWizardClickedThrough: boolean;
  partnerOfferingForm?: PartnerOfferingForm;
};

export type WizardActionPayload = {
  updatedAnswer?: PvWizardResultsQueryVariables;
  partnerOfferingForm?: PartnerOfferingForm;
};

export type WizardAction = {
  type: WizardActionType;
  payload?: WizardActionPayload;
  isWizardClickedThrough?: boolean;
};
